import {computeStatusTooltip, computeTitleTooltip} from 'notebook/tables/store/logic/TableTitleLogic';
import {createTableStoreSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore} from 'notebook/tables/store/TableStore';

import {TableContextModel} from './TableContextSelectors';

/**
 * The finished tooltip strings for the table title bar.
 */
export interface TableTitleModel {
  /** The schema description shown on the title bar, or null when there is nothing to show. */
  titleTooltip: string | null;

  /** The table status description shown on the table name, merged with the legacy `nameTooltip`. */
  statusTooltip: string;
}

/**
 * Creates a memoized selector that computes the {@link TableTitleModel} from the store.
 *
 * @param tableContextSelector - Selector to extract table context from the store
 */
export function createTableTitleSelector(
  tableContextSelector: (store: TableEditableStore) => TableContextModel
): (store: TableEditableStore) => TableTitleModel {
  return createTableStoreSelector(
    'tableTitle',
    {
      metadata: (store) => store.volatileProps.table.metadata,
      nameTooltip: (store) => store.volatileProps.table.nameTooltip,
      tableKind: (store) => tableContextSelector(store).tableKind,
      isConfigTable: (store) => tableContextSelector(store).isConfigTable,
      tableStatus: (store) => store.stableProps.tableStatus,
    },
    ({metadata, nameTooltip, tableKind, isConfigTable, tableStatus}) => ({
      titleTooltip: computeTitleTooltip(metadata, tableKind),
      statusTooltip: computeStatusTooltip(isConfigTable, tableStatus, nameTooltip),
    })
  );
}
